module.exports = __webpack_public_path__ + "static/media/remedi_logoV2.4de7734b.png";